import React, { useEffect } from 'react';
import { CheckCircle } from 'lucide-react';
import { candidateBenefits } from '../data/mock';
import { useTheme } from '../context/ThemeContext';

const CareersSection = () => {
  const { theme } = useTheme();

  useEffect(() => {
    // Load GoHighLevel form embed script
    const script = document.createElement('script');
    script.src = 'https://api.projectelevate.biz/js/form_embed.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      const existingScript = document.querySelector('script[src="https://api.projectelevate.biz/js/form_embed.js"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <section id="careers" className={`relative py-16 sm:py-20 lg:py-24 transition-colors duration-300 ${
      theme === 'dark' ? 'bg-black' : 'bg-gray-50'
    }`}>
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-[7.6923%]">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
          {/* Left Column */}
          <div>
            <div className={`inline-flex items-center gap-2 px-3 sm:px-4 py-2 mb-4 sm:mb-6 border ${
              theme === 'dark' ? 'border-white/20 bg-white/5' : 'border-gray-200 bg-white'
            }`}>
              <span className={`text-xs sm:text-sm font-medium tracking-wide uppercase ${
                theme === 'dark' ? 'text-white/70' : 'text-gray-600'
              }`}>Careers</span>
            </div>
            <h2 className={`text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 sm:mb-6 ${
              theme === 'dark' ? 'text-white' : 'text-gray-900'
            }`}>
              Join Our Talent Network
            </h2>
            <p className={`text-base sm:text-lg mb-6 sm:mb-8 ${
              theme === 'dark' ? 'text-white/70' : 'text-gray-600'
            }`}>
              Looking for IT opportunities? We connect talented professionals with top firms and innovative projects.
            </p>

            <div className="space-y-3">
              {candidateBenefits.map((benefit, index) => (
                <div key={index} className={`flex items-center gap-3 p-3 sm:p-4 ${
                  theme === 'dark' ? 'bg-[#0a0a0a] border border-white/10' : 'bg-white border border-gray-200'
                }`}>
                  <CheckCircle className={`w-5 h-5 flex-shrink-0 ${
                    theme === 'dark' ? 'text-[#00FFD1]' : 'text-[#00997A]'
                  }`} />
                  <span className={`text-sm sm:text-base ${
                    theme === 'dark' ? 'text-white/80' : 'text-gray-700'
                  }`}>{benefit}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column - GoHighLevel Form */}
          <div className={`p-5 sm:p-6 lg:p-8 ${
            theme === 'dark' ? 'bg-[#0a0a0a] border border-white/10' : 'bg-white border border-gray-200 shadow-sm'
          }`}>
            <h3 className={`text-xl sm:text-2xl font-bold mb-1 ${
              theme === 'dark' ? 'text-white' : 'text-gray-900'
            }`}>Submit Your Resume</h3>
            <p className={`text-sm mb-6 ${theme === 'dark' ? 'text-white/50' : 'text-gray-500'}`}>
              Start your journey with RKS Technologies
            </p>
            
            <div className="w-full" style={{ minHeight: '1070px' }}>
              <iframe
                src="https://api.projectelevate.biz/widget/form/5raZyVsQXtFsFmpUmfZd"
                style={{ width: '100%', height: '1070px', border: 'none', borderRadius: '3px' }}
                id="inline-5raZyVsQXtFsFmpUmfZd"
                data-layout="{'id':'INLINE'}"
                data-trigger-type="alwaysShow"
                data-trigger-value=""
                data-activation-type="alwaysActivated"
                data-activation-value=""
                data-deactivation-type="neverDeactivate"
                data-deactivation-value=""
                data-form-name="Contact Us - File Upload"
                data-height="1070"
                data-layout-iframe-id="inline-5raZyVsQXtFsFmpUmfZd"
                data-form-id="5raZyVsQXtFsFmpUmfZd"
                title="Contact Us - File Upload"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareersSection;
